module.exports = __webpack_public_path__ + "static/img/banner_f005.e70a549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f005.jpg
// module id = vBOV
// module chunks = 40